import { cx } from "shared/utils";
import { CriteriaBadgeIcon } from "shared/components/CriteriaBadgeIcon";
import { CriteriaBadgeMessage } from "shared/components/CriteriaBadgeMessage";
import { Show } from "shared/components";

import { ReactNode } from "react";

type StatProps = {
  title: string;
  suffix?: string;
  value: string | ReactNode;
  secondary_value?: string;
  className?: string;
  width?: string;
  height?: string;
  hasCriteria?: boolean;
  criteriaSuccess?: boolean;
  criteriaValue?: string | number;
  additionalCriteriaValue?: string;
  formattedCriteriaValue?: string | number;
  criteriaImportance?: number | null;
  criteriaYears?: number;
  subtitle?: string;
  hasTooltipExplainer?: boolean;
  tooltipExplainerContent?: ReactNode;
};

export const Stat = ({
  title,
  suffix,
  value,
  secondary_value,
  className,
  width,
  hasCriteria,
  criteriaSuccess,
  criteriaValue,
  height,
  additionalCriteriaValue,
  formattedCriteriaValue,
  criteriaImportance,
  criteriaYears,
  subtitle
}: StatProps) => {
  return (
    <div
      className={cx(className)}
      style={{
        width: width || "280px",
        height
      }}
    >
      <h3 className="text-xs font-medium text-content-700">
        {title}{" "}
        {suffix ? (
          <span className="font-regular text-content-200">({suffix})</span>
        ) : null}
      </h3>
      <div className="flex gap-2 items-center mt-2">
        {value === "--" || criteriaImportance == null ? null : (
          <CriteriaBadgeIcon
            hasCriteria={Boolean(hasCriteria)}
            success={Boolean(criteriaSuccess)}
          />
        )}

        <div className="flex flex-col">
          {typeof value === "string" ? (
            <p className="text-3xl font-bold text-content-1000">
              {value}{" "}
              {additionalCriteriaValue &&
              criteriaYears &&
              Number(value.replaceAll(/[^0-9.]/g, "")) !== 0 ? (
                <span className="text-sm text-content-300">
                  ({additionalCriteriaValue} within {criteriaYears} years)
                </span>
              ) : null}
            </p>
          ) : (
            value
          )}
          <Show if={secondary_value}>
            <div className="text-xs font-medium text-content-200">
              <p>{secondary_value}</p>
            </div>
          </Show>
        </div>
      </div>

      <Show if={subtitle}>
        <p className="text-content-400 text-xs leading-4 mt-2">{subtitle}</p>
      </Show>
      <div className="mt-2">
        {value === "--" ||
        typeof value !== "string" ||
        criteriaImportance == null ? null : (
          <CriteriaBadgeMessage
            criteriaTitle={title}
            hasCriteria={Boolean(hasCriteria)}
            success={Boolean(criteriaSuccess)}
            formattedValue={
              Boolean(criteriaYears)
                ? `${criteriaValue} within ${criteriaYears} years`
                : formattedCriteriaValue || criteriaValue || ""
            }
            value={Number(
              (additionalCriteriaValue || value).replaceAll(/[^0-9.]/g, "")
            )}
            criteriaValue={Number(
              String(formattedCriteriaValue || criteriaValue).replaceAll(
                /[%$,x]/g,
                ""
              )
            )}
          />
        )}
      </div>
    </div>
  );
};
